import type { TranslationResource } from './en';

export const tr: TranslationResource = {
  title: 'AutoCut - Yükleyici',
  downloading: 'AutoCut indiriliyor',
  downloadedTitle: 'AutoCut başarıyla indirildi !',
  closingCountdown: '{{count}} saniye içinde kapanıyor',
  alreadyInstalledTitle: 'AutoCut zaten yüklü',
  alreadyInstalledHelp:
    'AutoCut artık masaüstü uygulaması olarak çalışıyor. Bu uzantıyı Creative Cloud uygulamasından kaldırabilirsiniz.',
};
